import { useState } from "react";
import { useDispatch } from "react-redux";
import { registerUserSuccess } from "../redux/user/userSlice";
import conversion from "../assets/wito.png";
import backImage from "../assets/fondo.png";
import FieldIcon from "../utils/Register/field_icon";
import SendBtn from "../utils/Register/send_btn";
import DualFieldIcon from "../utils/Register/dual_field_icon";
import { FaLock, FaEnvelope } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const SignUpPage = () => {
  const navigate = useNavigate();
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!first_name || !last_name || !email || !password || !confirmPassword) {
      setError("Por favor, complete todos los campos.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ first_name, last_name, email, password }),
        },
      );

      if (!response.ok) {
        const errorMessage = `Error ${response.status}: ${response.statusText}`;
        throw new Error(errorMessage);
      }

      const data = await response.json();

      dispatch(
        registerUserSuccess({
          user: { first_name, last_name, email },
          token: data.token,
        }),
      );

      navigate("/profile");
    } catch (error) {
      setError(`Error al registrar usuario: ${error.message}`);
      console.error("Error al registrar usuario:", error.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen my-8">
      <div
        className="flex flex-col items-center bg-cover bg-center rounded-xl"
        style={{
          backgroundImage: `url(${backImage})`,
          maxWidth: "420px",
          padding: "0 5%",
          backgroundClip: "padding-box",
        }}
      >
        {/* Encabezado */}
        <div className="text-center text-white mb-8 mt-12">
          <h1 className="text-5xl font-bold">Hola</h1>
          <p className="text-lg mt-2">BIENVENIDO</p>
          <div className="flex justify-center mt-2">
            <img src={conversion} alt="Conversión" className="h-8" />
          </div>
        </div>

        {/* Formulario */}
        <div className="bg-white p-8 rounded-xl shadow-lg w-96">
          <h2 className="text-2xl font-bold text-center mb-6">
            Ingresa a tu cuenta
          </h2>
          <form onSubmit={handleSubmit}>
            {/* Campo de Correo */}
            <DualFieldIcon
              type1="text"
              placeholder1="Nombres"
              label1="Tu nombre"
              value1={first_name}
              onChange1={(e) => setFirstName(e.target.value)}
              type2="text"
              placeholder2="Apellidos"
              value2={last_name}
              onChange2={(e) => setLastName(e.target.value)}
            />
            <FieldIcon
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              placeholder="Introduce tu correo"
              value={email}
              required
              icon={<FaEnvelope />}
              label="Correo"
              onChange={(e) => setEmail(e.target.value)}
            />
            <FieldIcon
              type="password"
              placeholder="Introduce tu contraseña"
              icon={<FaLock />}
              label="Contraseña"
              id="password"
              name="password"
              autoComplete="password"
              value={password}
              required
              onChange={(e) => setPassword(e.target.value)}
            />
            <FieldIcon
              type="password"
              placeholder="Confirmar contraseña"
              icon={<FaLock />}
              label="Confirmar contraseña"
              id="password"
              name="password"
              autoComplete="password"
              value={confirmPassword}
              required
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            {/* Botón de entrada */}
            <SendBtn
              label="Entrar"
              type="submit"
              style={{ backgroundColor: "#E5960E" }}
            />
            <button onClick={() => navigate("/profile")}>test img</button>
            {error && <p className="text-red-500">{error}</p>}
          </form>

          {/* Registro */}
          <p className="text-center text-sm text-gray-700 mt-6">
            ¿Ya tienes una cuenta?{" "}
            <a href="/signin" className="text-blue-500 hover:underline">
              Ingresa
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUpPage;
